import { z } from 'zod';

export const UpdateCurationsOrderRequestSchema = z.object({
  type: z.enum(['GOODS', 'SNAP2']).optional(),
  curationIds: z.array(z.union([z.number(), z.string()])),
});

export type UpdateCurationsOrderRequest = z.infer<typeof UpdateCurationsOrderRequestSchema>;

export const UpdateCurationsOrderResponseSchema = z.object({
  success: z.boolean(),
});

export type UpdateCurationsOrderResponse = z.infer<typeof UpdateCurationsOrderResponseSchema>;
